module.exports = __webpack_public_path__ + "static/media/team.55c5e25c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/agency/assets/team.png
// module id = 229
// module chunks = 0